import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaggagesWrapperComponent } from './baggages-wrapper.component';
import { BaggagesModule } from '@shopping-angular-components/baggages';


@NgModule({
  declarations: [BaggagesWrapperComponent],
  exports: [
    BaggagesWrapperComponent
  ],
  imports: [
    CommonModule,
    BaggagesModule
  ]
})
export class BaggagesWrapperModule { }
